
import Vue from 'vue'
import { VIcon, VSkeletonLoader, VSpacer } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcHeadline',
  components: { VIcon, VSkeletonLoader, VSpacer },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    detailList: {
      type: Array as () => Array<string>,
      default: (): [] => [],
    },
    size: { type: String, default: 'h1' },
    color: { type: String, default: 'primary' },
    icon: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data: () => ({}),
})
